/* Prompted product hooks. Loaded before global.js and product-info.js.
 * Preserve custom behaviors here so future Dawn changes remain reviewable.
 * Dropdown invalid-variant correction retains its existing partial support.
 */
window.TCSProductHooks = {
  VariantSelects: (Base) => class extends Base {
    constructor() {
      super();
      this.isCustomSelecting = false;
      const sectionId = this.dataset.section;
      if (sectionId) {
        // check if the section data attribute is set.
        const variantValidityElement = document.getElementById(
          `data-variant-validity-${sectionId}`
        );
        if (variantValidityElement) {
          // check if the element exists.
          this.variantValidityData = JSON.parse(
            variantValidityElement.textContent
          );
        } else {
          // console.error(
          // `Element with ID 'data-variant-validity-${sectionId}' not found.`
          // );
          this.variantValidityData = {}; // default value or handle appropriately
        }
      } else {
        console.error(`section data attribute is not set.`);
        this.variantValidityData = {};
      }
      this.hideInvalidVariants = this.dataset.hideInvalidVariants === "true";
    }
    connectedCallback() {
      this.addEventListener("change", (event) => {
        if (!this.isCustomSelecting && this.hideInvalidVariants) {
          const selectedVariant = this.getSelectedVariant();
          if (!this.isValidVariant(selectedVariant)) {
            event.preventDefault();
            this.selectCustomVariant(event.target);
          } else {
            this.handlePropagation(event);
          }
        } else {
          this.handlePropagation(event);
        }
      });
      if (this.hideInvalidVariants) {
        this.hideInvalidVariantOptions();
      }
    }
    isValidVariant(selectedVariant) {
      let validityCheck = this.variantValidityData;
      for (let option of selectedVariant) {
        option = this.transformOptionValue(option);
        validityCheck = validityCheck[option];
        if (!validityCheck) return false;
      }
      return validityCheck.hasOwnProperty("valid") ? validityCheck.valid : true;
    }
    transformOptionValue(option) {
      return option
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-+$/, "");
    }
    getSelectedVariant() {
      return Array.from(this.querySelectorAll("fieldset")).map(
        (fieldset) => fieldset.querySelector("input:checked").value
      );
    }
    selectCustomVariant(originalTarget) {
      this.isCustomSelecting = true;
      const allFieldsets = Array.from(this.querySelectorAll("fieldset"));
      let changedOption = false;
      for (let i = allFieldsets.length - 1; i >= 0; i--) {
        const fieldset = allFieldsets[i];
        const options = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        );
        if (options.length > 0) {
          let currentIndex = options.findIndex((option) => option.checked);
          let nextValidOption = this.findNextValidOption(
            options,
            currentIndex,
            i
          );
          if (nextValidOption) {
            nextValidOption.checked = true;
            const newEvent = new Event("change", { bubbles: true });
            nextValidOption.dispatchEvent(newEvent);
            changedOption = true;
            break;
          }
        }
      }
      if (!changedOption) {
        this.resetToFirstValidCombination();
      }
      this.isCustomSelecting = false;
    }
    resetToFirstValidCombination() {
      const allFieldsets = Array.from(this.querySelectorAll("fieldset"));
      for (let i = 0; i < allFieldsets.length; i++) {
        const fieldset = allFieldsets[i];
        const options = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        );
        for (let option of options) {
          option.checked = true;
          if (this.isValidVariant(this.getSelectedVariant())) {
            const newEvent = new Event("change", { bubbles: true });
            option.dispatchEvent(newEvent);
            return;
          }
        }
      }
    }
    findNextValidOption(options, currentIndex, optionLevel) {
      const allFieldsets = Array.from(this.querySelectorAll("fieldset"));
      const selectedOptions = allFieldsets.map((fieldset) =>
        this.transformOptionValue(fieldset.querySelector("input:checked").value)
      );
      const findValidCombination = (currentOptions, level) => {
        if (level === allFieldsets.length) {
          return this.isValidVariant(currentOptions) ? currentOptions : null;
        }
        const fieldset = allFieldsets[level];
        const fieldOptions = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        );
        for (let option of fieldOptions) {
          const optionValue = this.transformOptionValue(option.value);
          const newOptions = [...currentOptions];
          newOptions[level] = optionValue;
          const result = findValidCombination(newOptions, level + 1);
          if (result) return result;
        }
        return null;
      };
      for (let i = 1; i <= options.length; i++) {
        const nextIndex = (currentIndex + i) % options.length;
        const nextOption = options[nextIndex];
        const nextValue = nextOption.value
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-");
        const testOptions = [...selectedOptions];
        testOptions[optionLevel] = nextValue;
        const validCombination = findValidCombination(
          testOptions,
          optionLevel + 1
        );
        if (validCombination) {
          for (let j = optionLevel + 1; j < allFieldsets.length; j++) {
            const fieldset = allFieldsets[j];
            const option = Array.from(
              fieldset.querySelectorAll('input[type="radio"]')
            ).find(
              (opt) =>
                opt.value.toLowerCase().replace(/[^a-z0-9]+/g, "-") ===
                validCombination[j]
            );
            if (option) option.checked = true;
          }
          return nextOption;
        }
      }
      return null;
    }
    hideInvalidVariantOptions() {
      const allFieldsets = Array.from(this.querySelectorAll("fieldset, select"));
      allFieldsets.forEach((fieldset, fieldsetIndex) => {
        const options =
          fieldset.tagName === "SELECT"
            ? Array.from(fieldset.querySelectorAll("option"))
            : Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        const selectedOptions = this.getSelectedVariant().map((val) =>
          this.transformOptionValue(val)
        );
        options.forEach((option) => {
          const optionValue = this.transformOptionValue(option.value);
          const variantToCheck = [...selectedOptions];
          variantToCheck[fieldsetIndex] = optionValue;
          let shouldHide;
          if (fieldsetIndex < allFieldsets.length - 1) {
            shouldHide = !this.hasValidCombination(
              variantToCheck,
              fieldsetIndex + 1
            );
          } else {
            shouldHide = !this.isValidVariant(variantToCheck);
          }
          let optionElement, labelElement, swatchDiv;
          if (fieldset.tagName === "SELECT") {
            optionElement = option;
          } else {
            optionElement = option;
            const optionId = option.getAttribute("id");
            const escapedId = CSS.escape(optionId);
            labelElement = fieldset.querySelector(`label[for="${escapedId}"]`);
            swatchDiv = option.closest(".product-form__swatch");
          }
          if (optionElement) {
            if (!shouldHide) {
              optionElement.style.display = "";
              optionElement.classList.remove("variant-select__hidden");
              if (labelElement) {
                labelElement.style.display = "";
                labelElement.classList.remove("variant-select__hidden");
              }
              if (swatchDiv) {
                swatchDiv.style.display = "";
                swatchDiv.classList.remove("variant-select__hidden");
              }
            } else {
              optionElement.style.display = "none";
              optionElement.classList.add("variant-select__hidden");
              if (labelElement) {
                labelElement.style.display = "none";
                labelElement.classList.add("variant-select__hidden");
              }
              if (swatchDiv) {
                swatchDiv.style.display = "none";
                swatchDiv.classList.add("variant-select__hidden");
              }
            }
          }
        });
      });
    }
    hasValidCombination(variantToCheck, startLevel) {
      return this.checkCombinationRecursive(variantToCheck, startLevel);
    }
    checkCombinationRecursive(variantToCheck, level) {
      const allFieldsets = Array.from(this.querySelectorAll("fieldset, select"));
      if (level === allFieldsets.length) {
        return this.isValidVariant(variantToCheck);
      }
      const fieldset = allFieldsets[level];
      const options =
        fieldset.tagName === "SELECT"
          ? Array.from(fieldset.querySelectorAll("option"))
          : Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      for (let option of options) {
        const optionValue = this.transformOptionValue(option.value);
        variantToCheck[level] = optionValue;
        if (this.checkCombinationRecursive(variantToCheck, level + 1)) {
          return true;
        }
      }
      return false;
    }
  },
  ProductInfo: (Base) => class extends Base {
    updateStickyATC(html) {
      const newStickyATCContainer = html.querySelector(".sticky-atc");
      const currentStickyATCContainer = this.querySelector(".sticky-atc");

      if (newStickyATCContainer && currentStickyATCContainer) {
        const newContent = newStickyATCContainer.innerHTML.trim();

        if (newContent === "") {
          currentStickyATCContainer.classList.add("hidden");
          currentStickyATCContainer.innerHTML = "";
        } else {
          currentStickyATCContainer.classList.remove("hidden");
          currentStickyATCContainer.innerHTML = newContent;
        }
      }
    }

    updateDescription(html) {
      const newDescriptionContainer = html.querySelector(
        ".variant__description"
      );
      const currentDescriptionContainer = this.querySelector(
        ".variant__description"
      );

      if (newDescriptionContainer && currentDescriptionContainer) {
        const newContent = newDescriptionContainer.innerHTML.trim();

        if (newContent === "") {
          // Hide the container if there's no content
          currentDescriptionContainer.classList.add("hidden");
          currentDescriptionContainer.innerHTML = "";
        } else {
          // Show and update the container if there's content
          currentDescriptionContainer.classList.remove("hidden");
          currentDescriptionContainer.innerHTML = newContent;
        }
      }
    }

    updateMediaGrouping() {
      const mediaGalleries = this.querySelectorAll("media-gallery");
      mediaGalleries.forEach((mediaGallery) => {
        const groupVariants = mediaGallery.getAttribute(
          "data-group-variants"
        );
        const hasOnlyDefaultVariant = mediaGallery.getAttribute(
          "data-has-only-default-variant"
        );
        const disableImageGrouping = mediaGallery.getAttribute(
          "data-disable-image-grouping"
        );

        if (
          groupVariants === "false" ||
          hasOnlyDefaultVariant === "true" ||
          disableImageGrouping === "true"
        ) {
          return;
        }

        const mediaItems = mediaGallery.querySelectorAll(
          ".product__media-item, .thumbnail-list__item"
        );
        const featuredMedia = Array.from(mediaItems).find(
          (media) => !media.classList.contains("hide-image")
        );
        const featuredVariantGrouping = featuredMedia
          ? featuredMedia.getAttribute("data-variant-grouping")
          : null;

        mediaItems.forEach((mediaItem) => {
          const mediaVariantGrouping = mediaItem.getAttribute(
            "data-variant-grouping"
          );
          if (mediaVariantGrouping === featuredVariantGrouping) {
            mediaItem.classList.remove("hide-image");
          } else {
            mediaItem.classList.add("hide-image");
          }
        });

        const modalContent = this.productModal?.querySelector(
          ".product-media-modal__content"
        );
        if (modalContent) {
          modalContent
            .querySelectorAll(".product-modal-image")
            .forEach((mediaItem) => {
              const mediaVariantGrouping = mediaItem.getAttribute(
                "data-variant-grouping"
              );
              mediaItem.classList.toggle(
                "hide-image",
                mediaVariantGrouping !== featuredVariantGrouping
              );
            });
        }
      });
    }

    updateQuantitySelector(html) {
      const newQuantitySelectorContainer = html.querySelector(
        "#Quantity-Form-" + this.sectionId
      );
      const currentQuantitySelectorContainer = document.querySelector(
        "#Quantity-Form-" + this.dataset.section
      );

      if (newQuantitySelectorContainer && currentQuantitySelectorContainer) {
        const newContent = newQuantitySelectorContainer.innerHTML.trim();

        if (newContent === "") {
          return;
        }

        currentQuantitySelectorContainer.innerHTML = newContent;

        this.quantityInput =
          currentQuantitySelectorContainer.querySelector(".quantity__input");
        this.initQuantityHandlers();
      }
    }

    updateTieredSelectorFromHtml(html) {
      const updatedOptions = html.querySelector(
        `.tiered-quantity-options[data-quantity-input-id="Quantity-${this.sectionId}"]`
      );
      if (!updatedOptions) return;

      const updatedContainer = updatedOptions.closest('.tiered-quantity-selector');
      if (!updatedContainer) return;

      const existingOptions = this.querySelector(
        `.tiered-quantity-options[data-quantity-input-id="Quantity-${this.sectionId}"]`
      );
      if (!existingOptions) return;

      const existingContainer = existingOptions.closest('.tiered-quantity-selector');
      if (!existingContainer) return;

      // Replace entire inner HTML block
      existingContainer.innerHTML = updatedContainer.innerHTML;

      // Reinitialize click events
      this.initTieredSelectorEvents();
    }

    initTieredSelectorEvents() {
      const container = this.querySelector(
        `.tiered-quantity-options[data-quantity-input-id="Quantity-${this.sectionId}"]`
      );
      if (!container) return;

      const quantityInput = document.getElementById(container.dataset.quantityInputId);
      const buttons = container.querySelectorAll('.tiered-option');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {

          // Reset all buttons
          buttons.forEach((b) => {
            b.classList.remove('tiered-option--active');
            b.style.background = '#FFFFFF';
            b.style.color = 'var(--text-color-unselected)';
          });

          // Activate the clicked option
          btn.classList.add('tiered-option--active');
          btn.style.background =
            getComputedStyle(btn).getPropertyValue('--selected-bg-color') || '#000000';
          btn.style.color = 'var(--text-color-selected)';

          // Update hidden quantity input
          const qty = parseInt(btn.getAttribute('data-quantity'), 10);
          if (quantityInput && !isNaN(qty)) {
            quantityInput.value = qty;
            quantityInput.dispatchEvent(new Event('change'));
          }
        });
      });
    }

    setStickyUnavailable() {
    const stickyATC = this.querySelector('.sticky-atc');
    if (stickyATC) {
      stickyATC.querySelectorAll('.sticky-atc-button').forEach((button) => {
        button.disabled = true;
        const label = button.querySelector('span');
        if (label) label.textContent = window.variantStrings.unavailable;
      });
      stickyATC.querySelectorAll('.sticky-atc-price').forEach((price) => price.classList.add('hidden'));
    }


    }
  },
};
